import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/style-component/components/panelStyle.js";
import { GridContainer, PanelBody } from "components";
import PropTypes from "prop-types";
import React from "react";
import { estilos } from "assets/jss/style-component/components/estiloComponente.js";

const useStyles = makeStyles(styles);

export default function Panel(props) {
  const {
    //className,
    children,
    //plain,
    //profile,
    //chart,
    cardSimple,
    ...rest
  } = props;
  const cardClasses = estilos(
    useStyles(),
    props,
    cardSimple ? "cardSimple" : "card"
  );

  return (
    <GridContainer>
      <div className={cardClasses} {...rest}>
        <PanelBody>{children}</PanelBody>
      </div>
    </GridContainer>
  );
}

Panel.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  chart: PropTypes.bool,
  children: PropTypes.node,
  cardSimple: PropTypes.string
};
